// Shared by useCachedFetch and apiFetch. The cache is module-level so it
// survives navigating between pages, but that also means a page that saves
// something (a decision in Arbejdskø, a licence, a user) would leave every
// other page showing the old copy until a hard refresh. apiFetch therefore
// calls invalidateFetchCache after every successful write; pages that are
// still mounted are told to refetch right away.
export const fetchCache = new Map();

const listeners = new Set();

export function subscribeFetchCache(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// '/api/audit-notes?tenantId=x' -> '/api/audit-notes'
export function cacheRootOf(path) {
  return String(path).split('?')[0].split('/').slice(0, 3).join('/');
}

export function invalidateFetchCache(path) {
  const root = cacheRootOf(path);
  [...fetchCache.keys()].forEach((key) => {
    if (key.startsWith(root)) fetchCache.delete(key);
  });
  listeners.forEach((listener) => listener(root));
}
